import whatsappLogo from "@/assets/whatsapp-logo.png";
import { cn } from "@/lib/utils";

interface WhatsAppIconProps {
  className?: string;
}

export default function WhatsAppIcon({ className }: WhatsAppIconProps) {
  return (
    <img
      src={whatsappLogo}
      alt=""
      width={28}
      height={28}
      decoding="async"
      className={cn("h-6 w-6 object-contain", className)}
      aria-hidden="true"
    />
  );
}